export const ACTUALIZAR_LIST_PROVEEDORES = "ACTUALIZAR_LIST_PROVEEDORES";
export const MODIFICAR_PROVEEDOR = "MODIFICAR_PROVEEDOR";
export const AGREGAR_PROVEEDOR = "AGREGAR_PROVEEDOR";  
export const ELIMINAR_PROVEEDOR = "ELIMINAR_PROVEEDOR";